import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Product } from '../domain/dtos/product'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetAvailableProducts {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(): Promise<Product[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/product/getAllAvailableInCreatorsPage/pt`,
      body: { data: null },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result
    }

    throw new GeneralError()
  }
}
